import { render, staticRenderFns } from "./TrackDetail.vue?vue&type=template&id=3d70d1ef"
import script from "./TrackDetail.vue?vue&type=script&lang=js"
export * from "./TrackDetail.vue?vue&type=script&lang=js"
import style0 from "./TrackDetail.vue?vue&type=style&index=0&id=3d70d1ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports